import React from 'react'

import { Button } from './styles'

function NavigationItem(props) {
  const { label, value, href, Icon, onClick } = props
  return (
    <Button
      data={href}
      className={value.includes(href) ? 'selected' : ''}
      onClick={onClick}
    >
      <span data={href}>
        <Icon fontSize="medium" />
      </span>
      <span className="label" data={href}>
        {label}
      </span>
    </Button>
  )
}

export default NavigationItem
